import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['checkAll', 'checkItem']

  checkAll() {
    this.checkItemTargets.forEach(target => {
      target.checked = this.checkAllTarget.checked;
    });
  }
}
